export const sectionTitleRowButtonSx = {
  width: '100%',
  height: 24,
  minWidth: 0,
  px: '12px',
  pt: 0,
  pb: '4px',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  bgcolor: 'transparent',
  color: 'inherit',
  '&:hover': { bgcolor: 'transparent' },
}

export const sectionTitleRowTitleSx = {
  fontWeight: 590,
  fontSize: 12,
  lineHeight: '120%',
  color: 'var(--app-text-primary)',
  whiteSpace: 'nowrap',
}

export const sectionTitleRowActionSx = (actionFilled, onActionClick) => ({
  px: '4px',
  borderRadius: '4px',
  cursor: onActionClick ? 'pointer' : 'default',
  bgcolor: actionFilled ? '#fcfbfa' : 'transparent',
})

export const sectionTitleRowActionLabelSx = {
  fontWeight: 590,
  fontSize: 10,
  lineHeight: '20px',
  color: 'var(--app-text-primary)',
}
